import React, { useState } from "react";
import { View, StyleSheet } from "react-native";
import NtModalUnactiveButton from "../../components/NtModalUnactiveButton";
import NtModalActiveButton from "../../components/NtModalActiveButton";
import NtModalInputField from "../../components/NtModalInputField";
import NtTabController from "../../components/NtTabController";
import NtModalInputTitle from "../../components/NtModalInputTitle";
import NtModalTitle from "../../components/NtModalTitle";
import NtModalSubtitle from "../../components/NtModalSubtitle";
import NtStrategyHint from "./NtStrategyHint";
import orderbyoptionsdata from "../../vvn/data/orderbyoptonsdata";
import ringgroupstrategytypesdata from "../data/ringgroupstrategytypesdata";

function NtRingGroupAdvancedSearchPicker({
  onCancel,
  onFilter,
  onFilterClear,
  filter,
}) {
  const [extension, setExtension] = useState(filter?.extension);
  const [callerIdName, setCallerIdName] = useState(filter?.callerIdName);
  const [callerIdNumber, setCallerIdNumber] = useState(filter?.callerIdNumber);
  const [strategy, setStrategy] = useState(
    ringgroupstrategytypesdata.find((each) => each.id == filter?.strategy)
  );
  const [orderBy, setOrderBy] = useState(
    orderbyoptionsdata.find((each) => each.id == filter?.orderBy)
  );

  const renderStrategy = (containerStyle) => {
    return (
      <View style={containerStyle}>
        <NtModalInputTitle style={{ marginLeft: 4 }}>Type</NtModalInputTitle>

        <NtTabController
          containerStyle={{ marginTop: 4 }}
          options={ringgroupstrategytypesdata}
          selection={strategy}
          onPress={(item) => {
            if (strategy?.id == item.id) {
              setStrategy(null);
            } else {
              setStrategy(item);
            }
          }}
        />

        <NtStrategyHint strategy={strategy} containerStyle={{ marginTop: 10 }} />
      </View>
    );
  };

  const renderOrderBy = (containerStyle) => {
    return (
      <View style={containerStyle}>
        <NtModalInputTitle style={{ marginLeft: 4 }}>
          Order By
        </NtModalInputTitle>

        <NtTabController
          containerStyle={{ marginTop: 4 }}
          options={orderbyoptionsdata}
          selection={orderBy}
          onPress={(item) => {
            if (orderBy?.id == item.id) {
              setOrderBy(null);
            } else {
              setOrderBy(item);
            }
          }}
        />
      </View>
    );
  };

  return (
    <View style={styles.container}>
      <NtModalTitle>Advanced Search</NtModalTitle>
      <NtModalSubtitle style={[{ marginTop: 4 }]}>
        Select specific parameters for search
      </NtModalSubtitle>

      <NtModalInputField
        containerStyle={{ marginTop: 15 }}
        title={"Extension"}
        placeholder={"Extension"}
        value={extension}
        setValue={(text) => setExtension(text)}
      />

      <NtModalInputField
        containerStyle={{ marginTop: 15 }}
        title={"Caller Name"}
        placeholder={"Caller Name"}
        value={callerIdName}
        setValue={(text) => setCallerIdName(text)}
      />
      <NtModalInputField
        containerStyle={{ marginTop: 15 }}
        title={"Caller Number"}
        placeholder={"Caller Number"}
        value={callerIdNumber}
        setValue={(text) => setCallerIdNumber(text)}
      />

      {renderStrategy({ marginTop: 15 })}

      {renderOrderBy({ marginTop: 15 })}

      <View
        style={{
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
          marginTop: 25,
        }}
      >
        <NtModalUnactiveButton title={"Cancel"} onPress={onCancel} />
        <View style={{ flexDirection: "row", alignItems: "center" }}>
          <NtModalUnactiveButton
            title={"Clear filters"}
            onPress={() => {
              setExtension("");
              setCallerIdName("");
              setCallerIdNumber("");

              setStrategy(null);
              setOrderBy(null);
              if (onFilterClear) {
                onFilterClear();
              }
            }}
          />
          <NtModalActiveButton
            containerStyle={{ marginLeft: 15 }}
            title={"Search"}
            enabled={true}
            onPress={() => {
              const next = {};
              if (extension) {
                next.extension = extension;
              }
              if (callerIdName) {
                next.callerIdName = callerIdName;
              }
              if (callerIdNumber) {
                next.callerIdNumber = callerIdNumber;
              }
              if (strategy) {
                next.strategy = strategy?.id;
              }
              if (orderBy) {
                next.orderBy = orderBy?.id;
              }

              if (onFilter) {
                onFilter(next);
              }
            }}
          />
        </View>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    minWidth: 500,
    maxWidth: 600,
    padding: 15,
  },
});

export default NtRingGroupAdvancedSearchPicker;
